
export enum AppAuthMode {
	authStart = 'authStart',
	authSuccess = 'authSuccess',
	authFailed = 'authFailed',
}